import api from '@/services/utils/apiInstance'

class ProductService {
  async getPaginatedNetworkAndStoreProductList(
    search,
    sort,
    order,
    page,
    limit,
    filters,
    storeId,
    signal = undefined
  ) {
    filters = Object.keys(filters).length !== 0 ? encodeURIComponent(JSON.stringify(filters)) : ''

    let encodedStoreId = encodeURIComponent(storeId)

    const url =
      '/distributor/product/list/' +
      encodedStoreId +
      '?search=' +
      encodeURIComponent(search) +
      '&sort=' +
      sort +
      '&order=' +
      order +
      '&page=' +
      page +
      '&limit=' +
      limit +
      '&filters=' +
      filters
    const response = await api.get(url, { signal })
    return response.data
  }

  async getProductList(productBoomerangId) {
    let encodedProductBoomerangId = encodeURIComponent(productBoomerangId)

    const url = '/distributor/product/all-by-product-boomerang-id/' + encodedProductBoomerangId
    const response = await api.get(url)
    return response.data
  }

  async getProductBreakdownList(productBoomerangId) {
    const encodedProductBoomerangId = encodeURIComponent(productBoomerangId)
    const response = await api.get(
      '/distributor/product-breakdown/all-by-product-boomerang-id/' + encodedProductBoomerangId
    )
    return response.data
  }

  async getProductQuestionList(productBreakdownId) {
    const encodedProductBreakdownId = encodeURIComponent(productBreakdownId)
    const response = await api.get(
      '/distributor/product-question/all-by-product-breakdown-id/' + encodedProductBreakdownId
    )
    return response.data
  }

  async getProductListBySubCategory(subCategoryBoomerangId) {
    let encodedSubCategoryBoomerangId = encodeURIComponent(subCategoryBoomerangId)
    const url =
      '/distributor/product/all-by-product-by-sub-category/' + encodedSubCategoryBoomerangId
    const response = await api.get(url)
    return response.data
  }

  async getProduct(productBoomerangId) {
    let encodedProductBoomerangId = encodeURIComponent(productBoomerangId)

    const response = await api.get('/distributor/product/' + encodedProductBoomerangId)
    return response.data
  }

  async askProductCreation(data) {
    const response = await api.post('/distributor/product/request', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  }

  async upsertProductRequestDraft(data) {
    const response = await api.put('/distributor/product/request/draft', data)
    return response.data
  }

  async getProductRequestDraftStatus(draftId) {
    const response = await api.get(
      '/distributor/product/request/draft/' + encodeURIComponent(draftId) + '/status'
    )
    return response.data
  }

  async getProductRequestDraftQrCodeToken(draftId) {
    const response = await api.get(
      '/distributor/product/request/draft/' + encodeURIComponent(draftId) + '/qr-code-token'
    )
    return response.data
  }

  async validateProductRequestDraftQrCodeToken(token) {
    const response = await api.post(
      '/distributor/product/request/draft/qr-code-token/validation',
      {
        qr_code_token: token
      },
      { publicCapability: true }
    )
    return response.data
  }

  async uploadProductRequestDraftNameplateFromPublicPage(data) {
    const response = await api.post('/distributor/product/request/draft/nameplate/public', data, {
      publicCapability: true,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  }

  async getAllProductByManufacturerWithBuybackPrices(manufacturerId) {
    const url = '/distributor/product/all/manufacturer/' + manufacturerId + '/with-buyback-prices'

    const response = await api.get(url)
    return response.data
  }
}

export default new ProductService()
